var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "fieldset",
    {
      staticClass: "option-select option-select--buttons",
      class: `option-select--${_vm.label.toLowerCase()}`
    },
    [
      _vm.label && _vm.label != "Size"
        ? _c("legend", { staticClass: "option-select__legend" }, [
            _c("span", { staticClass: "option-select__legend--title" }, [
              _vm._v(_vm._s(_vm.labelText) + " ")
            ]),
            _vm.label === "Color"
              ? _c(
                  "span",
                  { staticClass: "option-select__legend--selection" },
                  [_vm._v(_vm._s(_vm.value))]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "option-select__label-wrapper" },
        _vm._l(_vm.optionSet, function(option, index) {
          return _c(
            "label",
            {
              staticClass: "option-select__label",
              class: { "is-selected": option.value === _vm.value },
              attrs: {
                role: "button",
                tabindex: "0",
                for: `${_vm.label}-${index + 1}`,
                "aria-selected": _vm.ariaSelected(option)
              }
            },
            [
              _c("span", {
                staticClass: "sr-only",
                attrs: { "aria-label": _vm.ariaLabel(option) }
              }),
              _vm.label !== "Color"
                ? _c("span", { staticClass: "option-select__label-text" }, [
                    _vm._v(_vm._s(option.value))
                  ])
                : _vm._e(),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentValue,
                    expression: "currentValue"
                  }
                ],
                staticClass: "u-sr-only",
                attrs: {
                  type: "radio",
                  id: `${option.label}-${index + 1}`,
                  disabled: option.disabled,
                  name: option.label
                },
                domProps: {
                  value: option.value,
                  checked: _vm._q(_vm.currentValue, option.value)
                },
                on: {
                  change: [
                    function($event) {
                      _vm.currentValue = option.value
                    },
                    function($event) {
                      $event.preventDefault()
                      return _vm.onChange(option.value)
                    }
                  ]
                }
              })
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }